module.exports = __webpack_public_path__ + "static/media/jest.769cc506.png";